import React, { useState, useEffect } from 'react';

function Product({ productID, onClick }) {
    const [product, setProduct] = useState({});

    useEffect(() => {
        setProduct(productID)
    }, [productID]);
    
    return (
        <div>
            {product ? (
                <div className="product">
                    <a href={'#'+ product.id} onClick={() => onClick(product.id)}>
                        <img src={product.image} alt='Alternative text' className='icon'/>
                        <span>{product.title}</span>
                    </a>
                    
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
}

export default Product;
